import { useContextState } from "../../hooks/theme"

const useStyles = () => {
    const { colors } = useContextState()
    return {
        drawer: {
            '& .MuiPaper-root': {
                '& .MuiAccordion-root': {
                    padding: '8px',
                },
                '&:not(:last-child)': {
                    marginBottom: '15px',
                },
                maxWidth: '500px',
                padding: 3,
            },
        },
        defaultBtn: {
            background: colors.color13,
            padding: '10px 15px',
            borderRadius: '0px',
            '&:hover': {
                background: colors.color13,
                opacity: '0.95'
            }
        },
        titleEvidences: {
            fontSize: '16px',
            color: colors.color13,
            fontWeight: '600',
            marginBottom: '10px',
        },
        tabList: {
            borderBottom: 'none',
            '& .MuiTabs-indicator': {
                height: '0px'
            },
            '& .MuiTabs-flexContainer': {
                justifyContent: 'end',
                padding: '1px 2px 0px',
                background: colors.ashBlue,
                '& .Mui-selected': {
                    color: colors.color5,
                    background: colors.ash,
                }
            }
        },
        maxInput: {
            maxWidth: '150px',
            marginBottom: 2
        }
    }
}
export { useStyles }